export default "__VITE_ASSET__BClDq_Sm__"